import type { UUID } from '@/types/common'
import type {
  ExpensesResponse,
  ImportPaidRoadsResponse,
  ModifyReportRequest,
  Report,
  ReportsResponse,
} from '@/types/report'

import { api } from './client'

export interface ReconciliationResult {
  DownloadUrl: string
  Matched: number
  NotMatched: number
  Total: number
}

export interface GetReportsParams {
  driverID?: string;
  vehicleID?: string;
  page?: number;
  limit?: number;
  sort?: string[];
  from?: string;
  to?: string;
  document?: string;
}

export interface GetExpensesParams {
  name?: string;
  page?: number;
  limit?: number;
  sort?: string[];
}

export const reportsApi = {
  getReports: (params?: GetReportsParams) =>
    api.get<ReportsResponse>('/reports/advance', params),

  createReport: (data: ModifyReportRequest) =>
    api.post<Report>('/reports/advance', data),

  getReport: (id: UUID) =>
    api.get<Report>(`/reports/advance/${id}`),

  updateReport: (id: UUID, data: ModifyReportRequest) =>
    api.put<Report>(`/reports/advance/${id}`, data),

  deleteReport: (id: UUID) =>
    api.delete<void>(`/reports/advance/${id}`),

  getExpenses: (params?: GetExpensesParams) =>
    api.get<ExpensesResponse>('/reports/advance/expenses', params),

  generateReport: (id: UUID) =>
    api.post<Blob>(`/reports/advance/${id}/generate`, undefined, { responseType: 'blob' }),

  duplicateReport: (id: UUID) =>
    api.post<{ id: UUID }>(`/reports/advance/${id}/duplicate`, undefined),

  reconcileReport: (formData: FormData) =>
    api.post<ReconciliationResult>('/reports/advance/reconcile', formData),

  importPaidRoads: (formData: FormData, forceUpload?: boolean) =>
    api.post<ImportPaidRoadsResponse>('/reports/advance/roads', formData, { params: { forceUpload } }),

  downloadReconciledFile: (url: string) =>
    api.get<Blob>(url.startsWith('/api') ? url.substring(4) : url, undefined, { responseType: 'blob' }),
}
